import { Navigate } from "react-router-dom";
import { useAppSelector } from "../ReduxToolkit/Hooks";

const PrivateRouters = ({ children }: { children: React.ReactNode }): React.ReactElement | null => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return isAuthenticated ? <Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} /> : <>{children}</>;
};

export default PrivateRouters;
